import { libraries, sliderTypes, SlideshowFactory } from '@gebruederheitz/wp-block-slideshow/dist/frontend';

export const slideshows = () => {
    // Init all elements '.ghwp-slideshow' as slideshows
    new SlideshowFactory({
        debugEnabled: true,
        libraryOptionsUpdater: ({ parsedConfig, rawOptions, values }) => {
            if (
                values.lib === libraries.SWIPER &&
                values.sliderType === sliderTypes.SWIPER_COVERFLOW
            ) {
                return {
                    ...parsedConfig,
                    coverflowEffect: {
                        ...parsedConfig.coverflowEffect,
                        depth: 0,
                        scale: 1.15,
                        rotate: 40,
                    },
                };
            }

            return parsedConfig;
        },
    });
};
